import React from "react";
import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { CssTextField } from "../../components/TextField";
import SearchAndSelectInput from "../../components/SearchAndSelect";
import { capacitySummary } from "./presentation";
import { panelSx, SectionTitle, useColors } from "./ui";

function GuestSection({ draft, capacity, agentsList, field, onGuestField, onPatch }) {
    const colors = useColors();
    const { guest } = draft;
    const holds = capacitySummary(capacity);
    const guestInput = (key) => ({ value: guest[key], onChange: (e) => onGuestField(key, e.target.value) });

    return (
        <Box sx={panelSx(colors)}>
            <SectionTitle
                extra={
                    <Typography variant="body2" color={colors.grey[300]}>
                        * required
                    </Typography>
                }
            >
                Guest details
            </SectionTitle>
            <Grid container spacing={2}>
                <Grid item sm={6} xs={12}>
                    <CssTextField fullWidth required size="small" label="Guest name" {...guestInput("name")} {...field("guestName")} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <CssTextField
                        fullWidth
                        required
                        size="small"
                        type="email"
                        label="Guest email"
                        {...guestInput("email")}
                        {...field("guestEmail")}
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <CssTextField fullWidth size="small" type="tel" label="Phone" {...guestInput("phone")} helperText=" " />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <CssTextField fullWidth size="small" label="Address" {...guestInput("address")} helperText=" " />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <CssTextField
                        fullWidth
                        required
                        size="small"
                        type="number"
                        label="Adults (whole booking)"
                        value={draft.noOfAdults}
                        onChange={(e) => onPatch({ noOfAdults: e.target.value })}
                        inputProps={{ min: Math.max(capacity.rooms, 1) }}
                        {...field("adults", capacity.rooms ? `At least ${capacity.rooms}, 1 per room` : "Add a room first.")}
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <CssTextField
                        fullWidth
                        size="small"
                        type="number"
                        label="Children (whole booking)"
                        value={draft.noOfChilds}
                        onChange={(e) => onPatch({ noOfChilds: e.target.value })}
                        inputProps={{ min: 0 }}
                        {...field("childs")}
                    />
                </Grid>
            </Grid>
            <Typography variant="body2" color={colors.grey[300]}>
                {holds && `${holds} `}Guests are spread across all rooms when the booking is saved.
            </Typography>

            <Divider sx={{ my: 2 }} />
            <Typography fontWeight={600} mb={1.5}>
                Booking details
            </Typography>
            <Stack spacing={2}>
                <SearchAndSelectInput
                    keyname="first_name"
                    label="Agent (optional)"
                    value={draft.agentId}
                    list={agentsList || []}
                    onChange={(id) => onPatch({ agentId: id })}
                />
                <CssTextField fullWidth multiline minRows={2} size="small" label="Remarks" {...guestInput("remarks")} />
                <Typography variant="body2" color={colors.grey[300]}>
                    Prepaid. Payment is recorded only; nothing is charged here.
                </Typography>
            </Stack>
        </Box>
    );
}

export default GuestSection;
